import { Component } from "@angular/core";
import { fadeAnimation } from "./core/animations";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  animations: [fadeAnimation]
})
export class AppComponent {
  title = "jreader-admin";
}
